module.exports = __webpack_public_path__ + "static/media/Chuck-Approves.a2f0b8e0.jpg";